import React from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
//import indigo from "@material-ui/core/colors/indigo";
import CssBaseline from "@material-ui/core/CssBaseline";
function bankTheme(Component) {
  function BankTheme(props) {
    const theme = createMuiTheme(window.sco_custom_theme);
    // MuiThemeProvider makes the theme available down the React tree
    // thanks to React context.
    return (
      <MuiThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    );
  }

  return BankTheme;
}

export default bankTheme;